module.exports = __webpack_public_path__ + "img/ticket.d577537e.svg";